import type { OrderActionAvailability, OrderStatus } from "../types";

/**
 * Statuses where the customer may cancel or reschedule; everything else is
 * read-only.
 */
const ACTIONABLE_STATUSES: ReadonlySet<OrderStatus> = new Set([
  "INIT",
  "SCHD",
  "DISP",
  "RJCT",
  "ICMP",
]);

/** SAP priority whose orders may be cancelled but not rescheduled online. */
const NO_RESCHEDULE_PRIORITY = 5;

export function isActionableStatus(status: string): boolean {
  return ACTIONABLE_STATUSES.has(status as OrderStatus);
}

/**
 * Copy key explaining why an order can't be rescheduled online, or null when
 * it still can. Shared by the order page's inline note and the dashboard's
 * tooltip so both tell the customer the same thing.
 */
export function getOrderRestrictionKey(
  actions: OrderActionAvailability,
): "order.cancelOnly" | "order.notSchedulable" | null {
  if (actions.canReschedule) return null;
  return actions.canCancel ? "order.cancelOnly" : "order.notSchedulable";
}

export function getOrderActions(
  status: string,
  priority: number,
): OrderActionAvailability {
  const allowed = isActionableStatus(status);
  return {
    canCancel: allowed,
    canReschedule: allowed && priority !== NO_RESCHEDULE_PRIORITY,
  };
}
